import { LDMultiContext } from './launch-darkly-types';

/**
 * Generates an initial anonymous context for LaunchDarkly
 * This allows feature flags to work immediately, even before authentication
 */
export function generateInitialContext() {
  // Try to extract org/agent from current URL path
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const [org, agent] = pathParts;

  // Generate a stable anonymous user key
  // Using localStorage to persist across sessions
  let anonymousKey = localStorage.getItem('ld-anonymous-key');
  if (!anonymousKey) {
    anonymousKey = `anon-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('ld-anonymous-key', anonymousKey);
  }

  const context: LDMultiContext = {
    kind: 'multi',
    user: {
      key: anonymousKey,
      anonymous: true,
    },
  };

  // Add org/agent context if available from URL
  if (org && org !== 'auth') {
    context.organization = { key: org };
  }
  if (agent) {
    context.agent = { key: agent };
  }

  return context;
}
